// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { Box, Tab } from '@mui/material';
// Components, Layouts, Pages
import { BaseTabList } from '~/components/common';
import ChildrenPage from '~/pages/common/childrenPage/ChildrenPage';
import { TaskInformationPageTemplate } from '~/pages/template';
// Others
import { BACK_TO_PREVIOUS_PAGE, DEFAULT_NUMBER_ONE } from '~/utils/constants/common';
import { IBaseTabItem } from '~/utils/interface/common';
import { TaskDetailTabsEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './TaskDetail.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const TaskDetail = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/task']);
  const navigate = useNavigate();
  const { hash } = useLocation();
  const { id: taskId } = useParams();

  const getMenuItems = useCallback(() => {
    const items: Array<IBaseTabItem> = [
      { label: TaskDetailTabsEnum.INFORMATION, component: <TaskInformationPageTemplate /> },
    ];

    setTabItems(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [tabKey, setTabKey] = useState<string>('information');
  const [tabItems, setTabItems] = useState<IBaseTabItem[]>([]);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (hash) setTabKey(hash.slice(DEFAULT_NUMBER_ONE));
  }, [hash]);

  useEffect(() => {
    getMenuItems();
  }, [getMenuItems]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleBackToTask = () => {
    navigate(BACK_TO_PREVIOUS_PAGE);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    navigate(`#${newValue}`);
  };

  const renderTabContent = () => {
    const item = tabItems.find((tabItem: IBaseTabItem) => {
      return tabKey === tabItem.label;
    });

    return item?.component;
  };
  //#endregion Handle Function

  return (
    <ChildrenPage
      id='customerDetailPage'
      title={t('task_detail_title')}
      onBackToPreviousPage={handleBackToTask}
    >
      <Fragment>
        <BaseTabList value={tabKey} onChange={handleTabChange}>
          {tabItems.map((item, index) => (
            <Tab
              value={item.label}
              key={index}
              label={t(`tab_label_${item.label}`)}
              className={cx('tabItem')}
            />
          ))}
        </BaseTabList>

        <Box component={'div'} className={cx('tabContent')}>
          {renderTabContent()}
        </Box>
      </Fragment>
    </ChildrenPage>
  );
};

export default TaskDetail;
